import StarIcon from '@mui/icons-material/Star';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import React from 'react';
import { Activity } from 'shared/entities';

interface ActivityFeedProps {
  activities: Activity[];
}

const ActivityFeed: React.FC<ActivityFeedProps> = ({ activities }) => {
  const renderStars = (rating: number) => {
    return (
      <Box sx={{ display: 'flex', gap: 0.25, mb: 0.5 }}>
        {[...Array(5)].map((_, index) => (
          <StarIcon
            key={index}
            sx={{
              fontSize: 16,
              color: index < rating ? '#FDB833' : '#E0E0E0',
            }}
          />
        ))}
      </Box>
    );
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
          Recent Activity
        </Typography>

        {activities.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No recent activity
          </Typography>
        ) : (
          activities.map((activity, index) => (
            <Box key={activity.id}>
              <Box sx={{ py: 2 }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    mb: 0.5,
                  }}
                >
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {activity.title}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ whiteSpace: 'nowrap', ml: 2 }}
                  >
                    {activity.timestamp}
                  </Typography>
                </Box>

                {activity.rating && renderStars(activity.rating)}

                {activity.description && (
                  <Typography variant="body2" color="text.secondary">
                    {activity.description}
                  </Typography>
                )}
              </Box>
              {index < activities.length - 1 && <Divider />}
            </Box>
          ))
        )}
      </CardContent>
    </Card>
  );
};

export default ActivityFeed;
